var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"helps-article"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.article.title))]),_vm._v(" "),(_vm.detailData)?_c('p',{staticClass:"cont"},[_c('VueMarkdown',[_vm._v(_vm._s(this.detailData[0].content))])],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dcea28e6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/Tutorial/components/HelpsArticle.vue
// module id = T2PQ
// module chunks = 1